var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state)?_c('div',[(!_vm.showSuccess)?_c('span',[_vm._v("/")]):_vm._e(),_vm._v(" "),_c('span',{class:( _obj = {'badge-state': true}, _obj[_vm.vmiResource.migrationStateBackground] = true, _obj )},[_vm._v("\n    "+_vm._s(_vm.state)+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }